export default {
  buttons: {
    login: 'Iniciar sessão',
  },
  feedback: {
    incorrect_code: 'O código introduzido está incorreto. Por favor, tente novamente.',
    expired_code: 'Este código expirou. Por favor, solicite um novo.',
    too_many_attempts: 'Demasiadas tentativas. Aguarde um momento e tente novamente.',
    unknown: 'Ocorreu um erro ao verificar o seu código. Por favor, tente novamente.',
    network_error: 'Não foi possível contactar o servidor. Verifique a ligação e tente novamente.',
  },
};
